import { combineReducers } from "redux";
import home from "./home";
import detail from "./detail";

export default combineReducers({
  home,
  detail,
});
